import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import { editRichTextBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}
async function editRichText(blockId: number, blockDetails: any) {
  return await editRichTextBlock(blockId, blockDetails)
}

function* editRichTextBlockEffectSaga(action: any) {
  try {
    const { payload } = action

    const blockDetails = {
      block_rich_text: {
        content: payload.content,
      },
      block_instance: {
        name: payload.name,
        description: '',
        mandatory: false,
      },
    }

    yield call(editRichText, payload.id, blockDetails)
    const data = yield call(getList, payload.lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editRichTextBlockWatcherSaga() {
  yield takeLatest(fromActions.EDIT_RICHTEXT_BLOCK, editRichTextBlockEffectSaga)
}
